import { render, staticRenderFns } from "./thumb.vue?vue&type=template&id=2c304434&"
import script from "./thumb.vue?vue&type=script&lang=js&"
export * from "./thumb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports